
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    ecommerceObjects: {
        viewMode: 'list',
        rentList: [],
        loading: false,
        curBlocksObj: {},
    },
}
const EcommerceReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.ECOMMERCE_UPDATE_ECOMMERCEOBJECTS_START:
            return { loading: true };
        case actionTypes.ECOMMERCE_UPDATE_ECOMMERCEOBJECTS_SUCCESS:
            return { loading: false, ecommerceObjects: { ...state.ecommerceObjects, ...action.payload } }
        case actionTypes.ECOMMERCE_SET_LOADING:
            return { ...state, loading: action.payload }
        case actionTypes.ECOMMERCE_SET_INIT_ECOMMERCEOBJECTS:
            return { ...INITIAL_STATE };
        default:
            return state;
    }
}

export default EcommerceReducer;